"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatRoutes = void 0;
var ChatRoutes;
(function (ChatRoutes) {
    ChatRoutes["BasePrefix"] = "chats";
    ChatRoutes["ById"] = ":chatId";
    ChatRoutes["List"] = "list";
    ChatRoutes["Applications"] = "applications/:chatId";
})(ChatRoutes = exports.ChatRoutes || (exports.ChatRoutes = {}));
